import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import DocSidebar from './components/DocSidebar';
import GettingStarted from './pages/GettingStarted';
import EvidenceAPI from './pages/EvidenceAPI';
import WormAPI from './pages/WormAPI';
import AgentAPI from './pages/AgentAPI';

export default function App() {
  return (
    <div className="flex min-h-screen" style={{ background: 'var(--bg-primary)' }}>
      {/* Ambient glow orbs */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div
          className="absolute top-0 left-1/4 w-[600px] h-[600px] rounded-full blur-[120px]"
          style={{ background: 'radial-gradient(circle, rgba(0,212,255,0.04) 0%, transparent 70%)' }}
        />
        <div
          className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full blur-[100px]"
          style={{ background: 'radial-gradient(circle, rgba(0,102,255,0.05) 0%, transparent 70%)' }}
        />
      </div>

      {/* Sidebar */}
      <DocSidebar />

      {/* Main content area */}
      <main className="flex-1 relative z-10" style={{ marginLeft: '260px' }}>
        {/* Top bar */}
        <div
          className="sticky top-0 z-20 flex items-center justify-between px-8 py-3"
          style={{
            background: 'rgba(5,5,8,0.85)',
            backdropFilter: 'blur(12px)',
            borderBottom: '1px solid var(--border)',
          }}
        >
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4" style={{ color: 'var(--text-muted)' }} />
            <span className="text-xs font-mono" style={{ color: 'var(--text-secondary)' }}>
              Base URL
            </span>
          </div>
          <code className="text-sm font-mono" style={{ color: 'var(--accent-primary)' }}>
            https://api.noyka.ai
          </code>
        </div>

        <div className="max-w-4xl mx-auto px-8 py-12">
          <Routes>
            <Route path="/" element={<Navigate to="/getting-started" replace />} />
            <Route path="/getting-started" element={<GettingStarted />} />
            <Route path="/evidence-api" element={<EvidenceAPI />} />
            <Route path="/worm-api" element={<WormAPI />} />
            <Route path="/agent-api" element={<AgentAPI />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
